import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from './alert.service';
import { CrudService } from './crud.service';

@Injectable({
    providedIn: 'root'
})
export class CrudPromiseService<T> extends CrudService<T> {
    constructor(protected http: HttpClient, protected apiUrl: string, protected alertService: AlertService) {
        super(http, apiUrl);
    }

    indexPromise(obj?: any): Promise<Array<T>> {
        return new Promise<Array<T>>((resolve, reject) => {
            const subscription$: Subscription = super.index(obj).subscribe({
                next: (value) => {
                    resolve(value);
                    subscription$.unsubscribe();
                },
                error: (error) => {
                    this.alertService.toastErrorObject(error);
                    subscription$.unsubscribe();
                    reject(error);
                }
            });
        });
    }

    listMapPromise(obj: any): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            const subscription$: Subscription = super.listMap(obj).subscribe({
                next: (value) => {
                    resolve(value);
                    subscription$.unsubscribe();
                },
                error: (error) => {
                    this.alertService.toastErrorObject(error);
                    subscription$.unsubscribe();
                    reject(error);
                }
            });
        });
    }

    listPromise(obj?: any): Promise<Array<T>> {
        return new Promise<Array<T>>((resolve, reject) => {
            const subscription$: Subscription = super.list(obj).subscribe({
                next: (value) => {
                    resolve(value);
                    subscription$.unsubscribe();
                },
                error: (error) => {
                    this.alertService.toastErrorObject(error);
                    subscription$.unsubscribe();
                    reject(error);
                }
            });
        });
    }

    previewPdfPromise(id: number, attachments: boolean): Promise<HttpResponse<Blob>> {
        return new Promise<HttpResponse<Blob>>((resolve, reject) => {
            const subscription$: Subscription = super.previewPdf(id, attachments).subscribe({
                next: (value) => {
                    resolve(value);
                    subscription$.unsubscribe();
                },
                error: (error) => {
                    this.alertService.toastErrorObject(error);
                    subscription$.unsubscribe();
                    reject(error);
                }
            });
        });
    }

    showPromise(id: number | string, obj?: any): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            const subscription$: Subscription = super.show(id, obj).subscribe({
                next: (value) => {
                    resolve(value);
                    subscription$.unsubscribe();
                },
                error: (error) => {
                    this.alertService.toastErrorObject(error);
                    subscription$.unsubscribe();
                    reject(error);
                }
            });
        });
    }

    savePromise(element: T, successMessage: string = ''): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            const subscription$: Subscription = super.save(element).subscribe({
                next: (value) => {
                    this.alertService.toastSuccess(successMessage);
                    resolve(value);
                    subscription$.unsubscribe();
                },
                error: (error) => {
                    this.alertService.toastErrorObject(error);
                    subscription$.unsubscribe();
                    reject(error);
                }
            });
        });
    }

    createManyFromOnePromise(element: T, successMessage: string = ''): Promise<Array<T>> {
        return new Promise<Array<T>>((resolve, reject) => {
            const subscription$: Subscription = super.createManyFromOne(element).subscribe({
                next: (value) => {
                    this.alertService.toastSuccess(successMessage);
                    resolve(value);
                    subscription$.unsubscribe();
                },
                error: (error) => {
                    this.alertService.toastErrorObject(error);
                    subscription$.unsubscribe();
                    reject(error);
                }
            });
        });
    }

    adminSavePromise(id: number, element: T): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            const subscription$: Subscription = super.adminSave(id, element).subscribe({
                next: (value) => {
                    resolve(value);
                    subscription$.unsubscribe();
                },
                error: (error) => {
                    this.alertService.toastErrorObject(error);
                    subscription$.unsubscribe();
                    reject(error);
                }
            });
        });
    }

    deletePromise(id: number | string, urlParams?: URLSearchParams) {
        return new Promise<boolean>((resolve, reject) => {
            const subscription$: Subscription = super.delete(id, urlParams).subscribe({
                next: (value) => {
                    resolve(true);
                    subscription$.unsubscribe();
                },
                error: (error) => {
                    this.alertService.toastErrorObject(error);
                    subscription$.unsubscribe();
                    reject(error);
                }
            });
        });
    }
}
